module.exports = __webpack_public_path__ + "img/about01.394de0f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about01.jpg
// module id = Hg0y
// module chunks = 0